import { maxIndex } from "d3";
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";
import { BUSD, contract } from "../constants/addresses";
import { abis } from "../constants/erc";
import { getERC20Token, isAddress, setUpWeb3WithData, shortenAddress } from "../utils/utilsFunction";
import { IContext, TextContext } from "./context";
import { useActiveWeb3React } from "./useActiveWeb3React";

export const APIENDPOINT: { [key: string]: string } = {
    "1": "api.etherscan.io/api",
    "3": "",
    "56": "api.bscscan.com/api",
    "97": "api-testnet.bscscan.com/api",
    "137": "api.polygonscan.com/api",
    "80001": "api-testnet.polygonscan.com/api",
    "42261": "testnet.explorer.emerald.oasis.dev/api",
    "42262": "explorer.emerald.oasis.dev/api",
};

export const APIKEY: { [key: string]: string } = {
    "1": "",
    "3": "",
    "56":process.env.REACT_APP_API_KEY,
    "97":process.env.REACT_APP_API_KEY,
    "137": "89B4F6NVVEVGC8EMDCJVRJMVGSCVHHZTR7",
    "80001": "89B4F6NVVEVGC8EMDCJVRJMVGSCVHHZTR7",
    "42261": "",
    "42262": "",
};

const useTransactionHistory = (getValue:any,inputBox:string) =>{
   
    const {address,setIncoming,setOutgoing,setAddress,child,setIncomingData,setOutgoingData,setChildrens,childrens,setMaxIndex,setList,setLoading,setChild,ID,incomingTransaction,outgoingTransaction,setNodes,setLinks,maxIndex,setTotalIncoming,setTotalOutgoing,setETHBalance,setShowText} = React.useContext(TextContext) as IContext
    const {chainId,account,library} = useActiveWeb3React()
    const web3 = setUpWeb3WithData(1)
   
    useEffect(()=>{

        loadAccountHistory()
    },[chainId,getValue,child,address])

 
    const loadAccountHistory = async () => {
    
        
        if (inputBox || child) {
            // setLoading(true)
            let fetching ="main"
            try {
                setLoading(true)
                const uri = child && isAddress(child) ?`https://api.etherscan.com/api?module=account&action=txlist&address=${child}&startblock=0&endblock=99999999&page=1&offset=20&sort=asc&apikey=QKPV8MMKIZBVMBHWSW4NI2RFZ62EWPNU2J` :
                `https://api.etherscan.com/api?module=account&action=txlist&address=${inputBox}&startblock=0&endblock=99999999&page=1&offset=20&sort=asc&apikey=QKPV8MMKIZBVMBHWSW4NI2RFZ62EWPNU2J`;

                const data = await fetch(uri); //{ signal: AbortSignal.timeout(1000) }
                const jsondata = await data.json();
                  let result =[],to=[],from=[];
                if(child && isAddress(child)){
                    result = jsondata.result
                    fetching="child"
                }else{
                  const getBalance =async () =>{
                    
                       const ethBalance = await web3.eth.getBalance(address)
                       const ethBalanceInEther = web3.utils.fromWei(ethBalance, 'ether')
                       console.log({ethBalance,ethBalanceInEther})
                       setETHBalance(ethBalanceInEther)
                     }
                          getBalance()
                       
                  
                const balances = await fetch(`https://api.etherscan.io/api?module=account&action=tokentx&address=${inputBox}&page=1&offset=100&startblock=0&endblock=27025780&sort=asc&apikey=QKPV8MMKIZBVMBHWSW4NI2RFZ62EWPNU2J`)
                const dataBalance = await balances.json();
                let filteredBalance = dataBalance.result.map((item:any) =>({
                  tokenAddress:item.contractAddress,
                  tokenDecimal:item.tokenDecimal,
                  tokenName:item.tokenName,
                  tokenSymbol:item.tokenSymbol,
                }))

                const BalanceSet = new Set()
                const uniqueBalance = filteredBalance.filter((item:any) => {
                  const duplicate = BalanceSet.has(item.tokenAddress)
                  BalanceSet.add(item.tokenAddress)
                  return !duplicate
                })

                const balancesInfo =await Promise.all(uniqueBalance.map(async (item:any) => {
                  
                  const tokenContract = new web3.eth.Contract(abis.erc20,item.tokenAddress)
    const balance =await tokenContract.methods.balanceOf(address).call()
    const decimals = await tokenContract.methods.decimals().call()
    const formatttedBalance =ethers.utils.formatUnits(balance.toString(),decimals)
                  return {
                    tokenAddress:item.tokenAddress,
                    tokenDecimal:item.tokenDecimal,
                    tokenName:item.tokenName,
                    tokenSymbol:item.tokenSymbol,
                    balance: formatttedBalance
                  }
                }))
                setList(balancesInfo)
                  fetching="main"
                     from = jsondata.result.filter((item:any)=>item.from.toLowerCase() ===inputBox.toLowerCase())
                to = jsondata.result.filter((item:any)=>item.to.toLowerCase() === inputBox.toLowerCase())
             
                setIncoming(from)
                setOutgoing(to)
               setMaxIndex(prev=>prev+20)
                }

                setAddress(inputBox) 
             
                const onclick = (item) => {
                    setChild(item)
                }
                const getInFlow = (from:any)=>{
                    const GROUPS = 12;
                  const refineincoming = from.length> 0 ? from
                  .filter((thing:any, index:any, self:any) =>
                    index === self.findIndex((t:any) => (
                      t.to === thing.to
                    ))
                  ):[];
                  const totalIncoming = refineincoming.reduce((acc,cur)=>(cur.contractAddress==="") ? acc+parseFloat(ethers.utils.formatUnits(cur.value,6).toString()): acc,0)
                  setTotalIncoming(totalIncoming)
                  setIncomingData(refineincoming.slice(0,40))
                 const rfNodes= refineincoming.slice(0,20).map((item:any,index:number)=>({
                      id: index,
                      type: 'in',
                      data: { 
                        label: 'An input node',
                      sourcePosition:"right",
                      shortName:shortenAddress(item.to),
                      onClick:()=>onclick(item.to),
                      group: Math.ceil(Math.random() * GROUPS),
                      fullName:item.to,
                      value:parseFloat(ethers.utils.formatUnits(item.value,6).toString()).toFixed(2),
                      unicorn:child && item.from === child && result.length >500 ? true : false,
                    },
                     
                  }))
                   
                  const incomingChild = result.length>0 ? result
                  .slice(0,16)
                  .map((item:any,index:number)=>({
                    id:index+maxIndex,
                    shortName:shortenAddress(item.to===child ? item.from : item.to),
                      fullName:item.to===child ? item.from : item.to,   
                      'source': item.to===child ? index+maxIndex :ID,
                      'target': item.to===child ? ID :index+maxIndex ,
                      data:{
                        value:parseFloat(ethers.utils.formatUnits(item.value,6).toString()).toFixed(2),
                      } ,       
                      type:item.to===child ? "out" : "in" ,
                      style:{
                        background:item.to===child ? "#1CC700" : "#FF5300"
                      }
                  })):[]
                  setMaxIndex((prev:number)=>prev+incomingChild.length)
                    let prev = childrens ?? []
                    if(prev.length>0 && incomingChild.length>0){
const found = prev.find((item:any) => item[0].id === incomingChild[0].id);
                    if (!found) {
                      prev.push(incomingChild);
                      setChildrens(prev)
                    }
                    }else if(prev.length===0 && incomingChild.length>0){
                      prev.push(incomingChild);
                      setChildrens(prev)
                                         
                    }else if(prev.length===0&& incomingChild.length===0){
                      setChildrens(prev)
                    }else{
                      setChildrens([])
                    }
                    
                    
                
                  
                //   setInComingLength(incomingTransaction.length)
                  return {rfNodes,incomingChild}
                }
                const getOutFlow = (to:any)=>{
                    const GROUPS = 12
                  const refineoutgoing = to.length> 0 ?to
                  .filter((thing:any, index:any, self:any) =>
                    index === self.findIndex((t:any) => (
                      t.from === thing.from
                    ))
                  )
                  .map((item:any,idx:number)=>({
                    ...item,
                    key:idx
                  })) : []
                  const totalOutgoing = refineoutgoing.reduce((acc,cur)=>acc+parseFloat(ethers.utils.formatUnits(cur.value,6).toString()),0)
                  setTotalOutgoing(totalOutgoing)
                  setOutgoingData(refineoutgoing.slice(0,40))
                 const rfOutNodes= refineoutgoing.slice(0,20).map((item:any,index:number)=>({
                      id: item.key+8,
                      type: 'out',
                      shortName:shortenAddress(item.from),
                      group: Math.ceil(Math.random() * GROUPS),
                      data: { label: 'An input node',
                      onClick:()=>onclick(item.from),
                      fullName:item.from,
                      value:parseFloat(ethers.utils.formatUnits(item.value,6).toString()).toFixed(2),
                      unicorn:child && item.from === child && [...result].length >500 ? true : false,
                    },
                      position: { x: 400, y: 50+index*80 },
                       // @ts-ignore
                      targetPosition: 'left',
                     
                  }))
               
                  
                //   setInComingLength(incomingTransaction.length)
                  return {rfOutNodes}
                }
            

               const genRandomData= ()=> {
                const {rfNodes,incomingChild} = getInFlow(child && isAddress(child) ? incomingTransaction : from)
                
                const childData = Array.from(new Set([...childrens.flat()]))
                const {rfOutNodes} = getOutFlow(child && isAddress(child) ? outgoingTransaction : to)
                        const parentNode = [
                            {
                                id:1500,
                                shortName:shortenAddress(address),
                                fullName:"Parent",
                                data:{
                                  
                        unicorn:incomingTransaction &&  [...incomingTransaction,...outgoingTransaction] ? true : false,
                                },
                                value:0,
                                style:{background:"#FF5300"}
                            }
                        ]
                        const inLink = rfNodes
                        .map(id => ({
                            'source': 1500,
                            'target': id.id,
                            curvature:Math.random(),
                            type:"in",
                            click:child && child === id.data.fullName ? true : false,
                          }))
                          const parentLink = parentNode
                          .map(id => ({
                            'source': 1500,
                            'target': id.id,
                            curvature:Math.random(),
                          }))
                          const outLink = rfOutNodes
                            .map(id => ({
                                'source': id.id,
                                'target': 1500,
                                curvature:Math.random(),
                             
                            click:child && child === id.data.fullName ? true : false,
                            type:"out"
                                }))
                            const childLink = childData
                            .map(id => ({
                                'source': id.source,
                                'target': id.target,
                                type:id.type,
                            curvature:Math.random()
                                }))
                        return {
                          nodes: [...parentNode,...rfNodes,...rfOutNodes,...childData],
                                links: [
                                  ...inLink,
                                  ...parentLink,
                                  ...outLink,
                                  ...childLink,
                                  
                                  
                                ],
                        };
                      }
                    const {nodes,links} = genRandomData()
                
                      setNodes(nodes)
                      setLinks(links)
                setLoading(false)
              }catch (error){
                console.log(error)
                setShowText(false)
              } 
        } else {
            console.log('Wallet disconnected')
        }
    };
        
}

export default useTransactionHistory